module.exports = __webpack_public_path__ + "static/pcwarning.35ef2aaa.svg";